import React from 'react';
import '../styles/App.scss';
import '../styles/Cart.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
import CartDetails from './CartDetails';
import Resumen from './Resumen/Resumen';
import Footer from './Footer';

const Checkout = () => {
  return (
    <div className="cart-contenido">

    <Header confirmPay={true} changeCart={true} showCartCount />

    <div className="row-cart">
      <CartDetails />
      <Resumen />
    </div>
    <div className="cart-footer">
      <Footer />
    </div>
  </div>
  );
};

export default Checkout;
